<template>
  <div class="el-section">
    <div class="emd-container">
      <div class="emd-container__header eu-py_4_md eu-px_5_md">
        <h2 class="emd-text _size_section _color_default">
          {{ $t("title") }}
        </h2>
      </div>
      <hr class="emd-divider" />
      <div class="emd-container__content eu-pa_5_md">
        <emd-alert
          v-if="tabbarError.status && isCustomerValid"
          variant="danger"
          :title="$t('tabbarError.customer')"
          @cancel="tabbarError.status = false"
          autoclose
        />

        <form action="">
          <div class="eu-flex eu-column eu-row_md">
            <div class="eu-flex-item eu-basis_6_md">
              <div class="emd-form-group">
                <label class="emd-label _required" for="name">{{
                  $t("name")
                }}</label>
                <input
                  class="emd-input"
                  type="text"
                  name="name"
                  id="name"
                  v-model="customer.name"
                  :class="{
                    _state_error:
                      $v.customer.name.$invalid && showFeedbacks.status,
                  }"
                />
                <p
                  class="emd-input-feedback _state_error"
                  v-if="!$v.customer.name.maxLength && showFeedbacks.status"
                >
                  {{ $t("hint.length", { length: "64" }) }}
                </p>
                <p
                  class="emd-input-feedback _state_error"
                  v-else-if="$v.customer.name.$invalid && showFeedbacks.status"
                >
                  {{ $t("hint.required") }}
                </p>
              </div>
            </div>
            <div class="eu-flex-item eu-basis_6_md">
              <div class="emd-form-group">
                <label class="emd-label _required" for="email">{{
                  $t("email")
                }}</label>
                <input
                  class="emd-input"
                  type="email"
                  name="email"
                  id="email"
                  v-model="customer.email"
                  :class="{
                    _state_error:
                      $v.customer.email.$invalid && showFeedbacks.status,
                  }"
                />
                <p
                  class="emd-input-feedback _state_error"
                  v-if="!$v.customer.email.maxLength && showFeedbacks.status"
                >
                  {{ $t("hint.length", { length: "64" }) }}
                </p>
                <p
                  class="emd-input-feedback _state_error"
                  v-else-if="$v.customer.email.$invalid && showFeedbacks.status"
                >
                  {{ $t("hint.required") }}
                </p>
              </div>
            </div>
          </div>
          <div class="eu-flex eu-column eu-row_md">
            <div class="eu-flex-item eu-basis_6_md">
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  :class="{ _required: isBoleto || isPSP || isPix }"
                  for="document"
                  >{{ $t("document.label") }}</label
                >
                <the-mask
                  class="emd-input"
                  type="tel"
                  name="document"
                  id="document"
                  v-model="customer.document"
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                  :class="{
                    _state_error:
                      $v.customer.document.$invalid && showFeedbacks.status,
                  }"
                />
                <p class="emd-input-feedback">{{ $t("document.hint") }}</p>
                <p
                  class="emd-input-feedback _state_error"
                  v-if="
                    $v.customer.document.$invalid &&
                    showFeedbacks.status &&
                    (isBoleto || isPSP || isPix) &&
                    !customer.document.length
                  "
                >
                  {{ $t("hint.required") }}
                </p>
                <p
                  class="emd-input-feedback _state_error"
                  v-if="
                    $v.customer.document.$invalid &&
                    showFeedbacks.status &&
                    customer.document.length
                  "
                >
                  {{ $t("hint.document") }}
                </p>
              </div>
            </div>
            <div class="eu-flex-item eu-basis_3_md">
              <div class="emd-form-group">
                <label
                  :class="[
                    'emd-label',
                    { _required: contactNumberIsRequired || isPix },
                  ]"
                  for="cellphone"
                  >{{ $t("cellphone") }}</label
                >
                <the-mask
                  class="emd-input"
                  type="tel"
                  name="cellphone"
                  id="cellphone"
                  placeholder="21 00000-0000"
                  v-model="customer.mobile_phone"
                  :mask="['## #####-####']"
                  :class="{
                    _state_error:
                      $v.customer.mobile_phone.$invalid && showFeedbacks.status,
                  }"
                />
                <p
                  class="emd-input-feedback _state_error"
                  v-if="
                    $v.customer.mobile_phone.$invalid &&
                    showFeedbacks.status &&
                    !$v.customer.mobile_phone.minLength
                  "
                >
                  {{ $t("hint.mobile_phone") }}
                </p>
                <p
                  class="emd-input-feedback _state_error"
                  v-if="
                    $v.customer.mobile_phone.$invalid && showFeedbacks.status
                  "
                >
                  {{ $t("hint.phone") }}
                </p>
              </div>
            </div>
            <div class="eu-flex-item eu-basis_3_md">
              <div class="emd-form-group">
                <label
                  :class="['emd-label', { _required: contactNumberIsRequired }]"
                  for="telephone"
                  >{{ $t("telephone") }}</label
                >
                <the-mask
                  class="emd-input"
                  type="tel"
                  name="telephone"
                  id="telephone"
                  placeholder="21 00000-0000"
                  v-model="customer.home_phone"
                  :mask="['## ####-####']"
                  :class="{
                    _state_error:
                      $v.customer.home_phone.$invalid && showFeedbacks.status,
                  }"
                />
                <p
                  class="emd-input-feedback _state_error"
                  v-if="
                    $v.customer.home_phone.$invalid &&
                    showFeedbacks.status &&
                    !$v.customer.home_phone.minLength
                  "
                >
                  {{ $t("hint.home_phone") }}
                </p>
                <p
                  class="emd-input-feedback _state_error"
                  v-if="$v.customer.home_phone.$invalid && showFeedbacks.status"
                >
                  {{ $t("hint.phone") }}
                </p>
              </div>
            </div>
          </div>
          <section class="el-section">
            <div class="el-chunk">
              <div class="emd-form-box__header">
                <label class="emd-checkbox" for="showaddress">
                  <input
                    class="emd-checkbox__input"
                    name="showaddress"
                    type="checkbox"
                    id="showaddress"
                    v-model="address.show_address"
                  />
                  <div class="emd-checkbox__area"></div>
                  <span class="eu-ml_2">{{ $t("address.checkbox") }}</span>
                </label>
              </div>
            </div>
            <div
              class="emd-form-box"
              :class="{
                _active: address.show_address,
                _border_base: address.show_address,
              }"
            >
              <div class="emd-form-box__content">
                <address-form
                  :address="address"
                  @toggle="toggleAddressFormState"
                  @addressIsLoading="toggleLoadingAddress"
                />
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
    <div class="el-section">
      <div class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
        <button
          class="emd-btn _color_secondary _type_text _block_mobile"
          :disabled="loadingAddress"
          @click="reverseRoute"
        >
          <i class="uil uil-angle-left"></i>
          {{ $t(previousRoute) }}
        </button>
        <button
          class="emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm"
          :disabled="loadingAddress"
          @click="nextRoute"
        >
          {{ $t("PaymentData") }}
          <i class="uil uil-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import AddressForm from '@/components/project/AddressForm'
import {
  required,
  email,
  requiredIf,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'
import { validateDocument, isValidPhone } from '@/utils/validations'

export default {
  name: 'Customer',
  components: {
    EmdAlert,
    AddressForm
  },
  data () {
    return {
      addressFormIsInvalid: true,
      loadingAddress: false
    }
  },
  computed: {
    customer () {
      return this.$store.getters.customer
    },
    address () {
      return this.$store.getters.address
    },
    billingAddress () {
      return this.$store.getters.billing_address
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    formIsInvalid () {
      if (this.address.show_address) {
        return this.$v.$invalid || this.addressFormIsInvalid
      } else return this.$v.$invalid
    },
    isCustomerValid () {
      return this.$v.customer.$invalid
    },
    showAddress () {
      return this.address.show_address
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    tabbarError () {
      return this.$store.getters.tabbarError
    },
    isBoleto () {
      return this.getPaymentMethod === 'boleto'
    },
    isCheckout () {
      return this.getPaymentMethod === 'checkout'
    },
    isPSP () {
      return this.getBusinessModel === 'p_s_p'
    },
    isPix () {
      return this.getPaymentMethod === 'pix'
    },
    getPaymentMethod () {
      return this.$store.getters.selectedPaymentMethod
    },
    getBusinessModel () {
      return this.$store.getters.business_model
    },
    getMobilePhone () {
      return this.customer.mobile_phone
    },
    getHomePhone () {
      return this.customer.home_phone
    },
    contactNumberIsRequired () {
      const isBoletoOrCreditCard = ['boleto', 'credit_card'].includes(
        this.getPaymentMethod
      )
      return isBoletoOrCreditCard && this.isPSP
    },
    previousRoute () {
      return this.selectedPaymentType === 'subscription'
        ? 'SubscriptionDetails'
        : 'PaymentMethod'
    },
    canRemoveAddress () {
      return (
        this.billingAddress.use_client_address && !this.address.show_address
      )
    }
  },
  validations () {
    return {
      customer: {
        name: {
          required,
          maxLength: maxLength(64)
        },
        email: {
          required,
          email,
          maxLength: maxLength(64)
        },
        document: {
          validateDocument,
          required: requiredIf(function () {
            return this.isBoleto || this.isPSP || this.isPix
          })
        },
        home_phone: {
          isValidPhone,
          required: requiredIf(function () {
            return this.contactNumberIsRequired && !this.getMobilePhone
          }),
          minLength: minLength(10)
        },
        mobile_phone: {
          isValidPhone,
          required: requiredIf(function () {
            return (
              this.isPix || (this.contactNumberIsRequired && !this.getHomePhone)
            )
          }),
          minLength: minLength(11)
        }
      }
    }
  },
  methods: {
    nextRoute () {
      if (this.formIsInvalid) {
        this.showFeedbacks.status = true
        if (this.showAddress) this.showFeedbacks.address = true
      } else {
        this.$router.push({ name: 'PaymentData' })
      }
    },
    reverseRoute () {
      this.$router.push({ name: this.previousRoute })
    },
    toggleAddressFormState (state) {
      this.addressFormIsInvalid = state
    },
    toggleLoadingAddress (state) {
      this.loadingAddress = state
    }
  },
  watch: {
    formIsInvalid: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: this.formIsInvalid,
          component: this.$route.name,
          paymentType: this.selectedPaymentType
        })
        this.tabbarError.status = false
        this.showFeedbacks.status = false
      }
    },
    showAddress: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: this.formIsInvalid || this.canRemoveAddress,
          component: 'PaymentData',
          paymentType: this.selectedPaymentType
        })
      }
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Para quem será essa cobrança?",
      "name": "Nome Completo",
      "email": "Email",
      "orderData": "Dados do pedido",
      "document": {
        "label": "CPF ou CNPJ",
        "hint": "Digite somente números."
      },
      "telephone": "Telefone com ddd",
      "cellphone": "Celular com ddd",
      "address": {
        "title": "Endereço",
        "checkbox": "Adicionar Endereço",
        "zipcode": {
          "label": "CEP",
          "hint": "CEP não encontrado.",
          "link": "Não sei meu CEP"
        },
        "street": {
          "label": "Logradouro",
          "hint": "Digite a rua, avenida ou similar"
        },
        "number": {
          "label": "Número",
          "hint": "Digite somente números."
        },
        "complement": {
          "label": "Complemento",
          "hint": "Digite somente números e/ou letras."
        },
        "neighborhood": "Bairro",
        "city": "Cidade",
        "state": "Estado",
        "country": "País"
      },
      "PaymentMethod": "Tipos de Pagamento",
      "PaymentData": "Dados do Pagamento",
      "SubscriptionDetails": "Dados da Recorrência",
      "hint": {
        "required": "Este campo é obrigatório",
        "document": "Documento deve ser válido",
        "home_phone": "O telefone deve ter 10 dígitos",
        "mobile_phone": "O celular deve ter 11 dígitos",
        "zip_code": "O CEP deve ter 8 dígitos",
        "phone": "Número inválido",
        "length": "Este campo deve conter até {length} caracteres"
      },
      "tabbarError": {
        "customer": "Alguns campos não foram preenchidos corretamente, por favor verifique.",
        "address": "Para prosseguir é necessário preencher todos os campos marcados como obrigatórios."
      }
    },
    "en-US": {
      "title": "Who will receive this order?",
      "name": "Full Name",
      "email": "Email",
      "orderData": "Order Items",
      "document": {
        "label": "CPF or CNPJ",
        "hint": "Insert numbers only."
      },
      "telephone": "Telephone with ddd",
      "cellphone": "Cellphone with ddd",
      "address": {
        "title": "Address",
        "checkbox": "Add Address",
        "zipcode": {
          "label": "Zip code",
          "hint": "CEP not found.",
          "link": "I do not know my zipcode"
        },
        "street": {
          "label": "Line 1",
          "hint": "Insert a street, avenue or similar"
        },
        "number": {
          "label": "Number",
          "hint": "Insert numbers only."
        },
        "complement": {
          "label": "Line 2",
          "hint": "Insert numbers and/or letters only."
        },
        "neighborhood": "neighborhood",
        "city": "City",
        "state": "State",
        "country": "Country"
      },
      "PaymentMethod": "Payment Method",
      "PaymentData": "Payment Data",
      "SubscriptionDetails": "Subscription Details",
      "hint": {
        "required": "This field is required",
        "document": "Document must be valid",
        "home_phone": "The telephone number must be a 10-digit phone number",
        "mobile_phone": "The cellphone number must be a 11-digit phone number",
        "zip_code": "Zip Code must be a 8-digit number",
        "phone": "Invalid number",
        "length": "This field cannot be more than {length} characters"
      },
      "tabbarError": {
        "customer": "Some fields were filled incorrectly, please verify.",
        "address": "To move forward it is necessary to fill all fields marked as required."
      }
    }
  }
</i18n>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
